import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
// import swal from 'sweetalert';
import { useStoreState } from 'easy-peasy';

import UserActivity from './UserActivity';

import Layout from '../../../components/global/Layout';
import { Loading } from '../../../components/elements';
import client from '../../../utils/apolloClient';

const placeQuery = gql`
  query searchPlace($input: SearchInput) {
    search_places(input: $input) {
      place_listing {
        place_id
        name
        status
      }
    }
  }
`;
const placeActivityQuery = gql`
  query placeActivity($input: SearchInput) {
    search_place_activity(input: $input) {
      deals {
        deals_total
        deals_active
        deals_past
        deals_future
      }
      feeds {
        feeds_total
        feeds_flagged
      }
      followers
    }
  }
`;

const Event = ({ match }) => {
  const { placeId } = match.params;
  const { userId } = useStoreState(state => state.auth);
  return (
    <Layout>
      <Query
        query={placeQuery}
        variables={{
          input: {
            place_id: placeId,
            user_id: userId,
          },
        }}
        fetchPolicy="network-only"
        client={client.clientPrivate}
      >
        {({ data: placeData, loading: placeLoading, error }) => {
          if (placeLoading) {
            return <Loading />;
          }
          if (error) {
            return 'error';
          }
          const { search_places } = placeData;

          return (
            <Query
              client={client.clientPrivate}
              query={placeActivityQuery}
              variables={{
                input: {
                  filter: {
                    social_filter: {
                      object_id: search_places.place_listing.place_id,
                      object_type: 'PLACE',
                    },
                  },
                },
              }}
              fetchPolicy="network-only"
            >
              {({ data: activityData, loading, error: error2 }) => {
                if (loading) {
                  return <Loading />;
                }

                if (error2) {
                  return JSON.stringify(error);
                }

                const { search_place_activity } = activityData;

                return (
                  <UserActivity
                    activity={search_place_activity}
                    place={search_places}
                  />
                );
              }}
            </Query>
          );
        }}
      </Query>
    </Layout>
  );
};

export default Event;
